import {
    ORDER_STATISTIC
  } from '../constants/types';

  export default function(state=[], action){
    switch(action.type){
      case ORDER_STATISTIC:
        return action.payload
      default:
        return state
    }
  }
